import { render, staticRenderFns } from "./TrafikCezasiHesapPlaniView.vue?vue&type=template&id=6ae13b2e&"
import script from "./TrafikCezasiHesapPlaniView.vue?vue&type=script&lang=js&"
export * from "./TrafikCezasiHesapPlaniView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports